import { memo } from 'react';
import { Logo } from "../Header/Logo";
import styles from './Layout.module.scss';

type ErrorLayout = {
    text?: string;
}

export const Error = memo(({ text }: ErrorLayout) => {
    return <div className={styles.errorContainer}>
        <Logo scale={3}/>
        <h3 style={{ textAlign: 'center' }}>{text}</h3>
    </div>
})
